__turbopack_context__.v({
  "absolute": "styles-module__f5XxYq__absolute",
  "bottomContainer": "styles-module__f5XxYq__bottomContainer",
  "contact": "styles-module__f5XxYq__contact",
  "contactsContainer": "styles-module__f5XxYq__contactsContainer",
  "icon": "styles-module__f5XxYq__icon",
  "social": "styles-module__f5XxYq__social",
  "socialContainer": "styles-module__f5XxYq__socialContainer",
});
